module.exports = __webpack_public_path__ + "img/whyOrange.b0aded62.jpg";